import { Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from '../../services/app-config.service';

@Pipe({
    name: 'orgTerm',
    pure: false
})
export class OrgTermPipe implements PipeTransform {
    constructor(private configService: AppConfigService) {}

    transform(value: string): string {
        try {
            const terms = this.configService.get('terminology');
            if (terms && terms[value]) {
                return terms[value];
            }
            // Fallback defaults if config is missing key (optional)
            switch(value) {
                case 'shtibel': return 'שטיבל';
                case 'shtibels': return 'שטיבלך';
                case 'member': return 'מתפלל';
                case 'members': return 'מתפללים';
            }
            return value;
        } catch (e) {
            return value;
        }
    }
}
